/* VCTparts smart search (sections/vct-smart-search.liquid). Moved out of the
   section so the browser caches it; the settings come from the section's
   [data-vct-config] JSON. */
(function(){
  'use strict';
  if (window.VCTSmartSearch) return;
  var cfgEl = document.querySelector('[data-vct-config]');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);

  /* ================================================================
     VCT-CORE-START  — tekstnormalisatie, fuzzy matching, synoniemen
     ================================================================ */
  var CORE = (function(){
    function normalize(str){
      return String(str || '')
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s\-\/\.]/g, ' ')
        .replace(/(\d)[\.,](\d)/g, '$1$2')
        .replace(/[\-\/\.]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }
    function tokenize(str){
      var n = normalize(str);
      if (!n) return [];
      var parts = n.split(' ');
      // "h 7" -> "h7", "12 v" -> "12v", zodat "h7 led" en "h 7 led" hetzelfde zijn
      var out = [];
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (!p) continue;
        var prev = out[out.length - 1];
        if (prev && ((/^[a-z]{1,2}$/.test(prev) && /^\d{1,3}[a-z]?$/.test(p)) || (/^\d{1,3}$/.test(prev) && /^[a-z]{1,2}$/.test(p)))) {
          out[out.length - 1] = prev + p;
        } else out.push(p);
      }
      return out;
    }
    // Damerau-Levenshtein (optimal string alignment), met vroege stop
    function editDistance(a, b, max){
      if (a === b) return 0;
      var la = a.length, lb = b.length;
      if (Math.abs(la - lb) > max) return max + 1;
      var prev2 = null, prev = [], cur = [], i, j;
      for (j = 0; j <= lb; j++) prev[j] = j;
      for (i = 1; i <= la; i++) {
        cur = [i];
        var rowMin = i;
        for (j = 1; j <= lb; j++) {
          var cost = a[i-1] === b[j-1] ? 0 : 1;
          var v = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + cost);
          if (i > 1 && j > 1 && a[i-1] === b[j-2] && a[i-2] === b[j-1]) v = Math.min(v, prev2[j-2] + 1);
          cur[j] = v;
          if (v < rowMin) rowMin = v;
        }
        if (rowMin > max) return max + 1;
        prev2 = prev; prev = cur;
      }
      return prev[lb];
    }
    function bigrams(s){
      var set = {}; s = ' ' + s + ' ';
      for (var i = 0; i < s.length - 1; i++) set[s.substr(i, 2)] = 1;
      return set;
    }
    function dice(a, b){
      var A = bigrams(a), B = bigrams(b), inter = 0, na = 0, nb = 0, k;
      for (k in A) { na++; if (B[k]) inter++; }
      for (k in B) nb++;
      return (2 * inter) / (na + nb || 1);
    }
    function allowedDistance(len){
      if (len <= 3) return 0;
      if (len <= 5) return 1;
      if (len <= 8) return 2;
      return 3;
    }
    // Synoniemen: "dashcam: dash cam, autocamera" per regel -> alias -> [groep]
    function parseSynonyms(raw){
      var groups = [], map = {};
      String(raw || '').split(/\r?\n/).forEach(function(line){
        line = line.trim(); if (!line) return;
        var words = line.split(/[:,;]/).map(function(w){ return normalize(w); }).filter(Boolean);
        if (words.length < 2) return;
        // Zet meerwoord-synoniemen ook als samengevoegd woord: "dash cam" -> "dashcam"
        var group = [];
        words.forEach(function(w){ group.push(w); if (w.indexOf(' ') > -1) group.push(w.replace(/ /g, '')); });
        groups.push(group);
        group.forEach(function(w){ map[w] = (map[w] || []).concat([groups.length - 1]); });
      });
      return { groups: groups, map: map };
    }
    // Breid querytokens uit met synoniemen; geeft lijst van alternatieven per token
    function expandTokens(tokens, syn){
      var out = [];
      var joined = ' ' + tokens.join(' ') + ' ';
      // Meerwoordige aliassen ("ramen blinderen") in de hele query herkennen:
      // de losse woorden worden optioneel en de groep (raamfolie, tintfolie, …) wordt één verplicht token
      var covered = {}, extraGroups = [];
      Object.keys(syn.map).forEach(function(alias){
        if (alias.indexOf(' ') > -1 && joined.indexOf(' ' + alias + ' ') > -1) {
          alias.split(' ').forEach(function(w){ covered[w] = 1; });
          syn.map[alias].forEach(function(gi){
            var alts = [];
            syn.groups[gi].forEach(function(w){ if (w.indexOf(' ') < 0 && alts.indexOf(w) < 0) alts.push(w); });
            if (alts.length) extraGroups.push(alts);
          });
        }
      });
      tokens.forEach(function(t){
        var alts = [t];
        (syn.map[t] || []).forEach(function(gi){
          syn.groups[gi].forEach(function(w){ if (alts.indexOf(w) < 0 && w.indexOf(' ') < 0) alts.push(w); });
        });
        if (covered[t]) alts.push('__optional__');
        out.push(alts);
      });
      extraGroups.forEach(function(g){ out.push(g); });
      return out;
    }

    function buildIndex(items){
      var vocab = {}, docs = [];
      items.forEach(function(it){
        var titleTokens = tokenize(it.t);
        var otherTokens = tokenize([it.y, it.v, it.g, it.s].join(' '));
        var tokens = titleTokens.concat(otherTokens);
        var seen = {};
        tokens.forEach(function(t){ if (!seen[t]) { seen[t] = 1; vocab[t] = (vocab[t] || 0) + 1; } });
        docs.push({ item: it, title: titleTokens, other: otherTokens, all: seen, titleStr: titleTokens.join(' ') });
      });
      var vocabList = Object.keys(vocab).map(function(w){ return { w: w, n: vocab[w] }; });
      return { docs: docs, vocab: vocab, vocabList: vocabList };
    }

    // VCT perf: zelfde resultaat als buildIndex, maar in stukjes zodat de main thread
    // elke ~50 ms vrijkomt (geen lange taak van >1 s op mobiel). Geeft een Promise terug.
    function buildIndexAsync(items, budgetMs){
      budgetMs = budgetMs || 50;
      var vocab = {}, docs = [], i = 0, n = items.length;
      var now = (typeof performance !== 'undefined' && performance.now) ? function(){ return performance.now(); } : Date.now;
      var yieldNow = (typeof scheduler !== 'undefined' && scheduler && typeof scheduler.yield === 'function')
        ? function(){ return scheduler.yield(); }
        : function(){ return new Promise(function(r){ setTimeout(r, 0); }); };
      return new Promise(function(resolve, reject){
        function step(){
          try {
            var start = now();
            while (i < n) {
              var it = items[i++];
              var titleTokens = tokenize(it.t);
              var otherTokens = tokenize([it.y, it.v, it.g, it.s].join(' '));
              var tokens = titleTokens.concat(otherTokens);
              var seen = {};
              tokens.forEach(function(t){ if (!seen[t]) { seen[t] = 1; vocab[t] = (vocab[t] || 0) + 1; } });
              docs.push({ item: it, title: titleTokens, other: otherTokens, all: seen, titleStr: titleTokens.join(' ') });
              if ((i & 31) === 0 && now() - start > budgetMs) { yieldNow().then(step, step); return; }
            }
            var vocabList = Object.keys(vocab).map(function(w){ return { w: w, n: vocab[w] }; });
            resolve({ docs: docs, vocab: vocab, vocabList: vocabList });
          } catch(e){ reject(e); }
        }
        step();
      });
    }

    // Score van één querytoken (met alternatieven) tegen één document
    function scoreToken(alts, doc){
      var best = 0;
      for (var a = 0; a < alts.length; a++) {
        var q = alts[a];
        if (q === '__optional__') continue;
        var isSyn = a > 0;
        var base = isSyn ? 0.6 : 1;
        if (doc.all[q]) { // exact token
          best = Math.max(best, (doc.title.indexOf(q) > -1 ? 10 : 6) * base); continue;
        }
        if (doc.titleStr.indexOf(q) > -1) { best = Math.max(best, 7 * base); continue; } // deel van titel ("led" in "ledlamp")
        var maxD = allowedDistance(q.length);
        var tokens = Object.keys(doc.all);
        for (var i = 0; i < tokens.length; i++) {
          var t = tokens[i];
          if (t.indexOf(q) === 0) { best = Math.max(best, (doc.title.indexOf(t) > -1 ? 8 : 5) * base); continue; } // prefix
          if (q.length >= 4 && t.indexOf(q) > -1) { best = Math.max(best, 4.5 * base); continue; }
          if (q.length >= 5 && q.indexOf(t) > -1 && t.length >= 4) { best = Math.max(best, 3.5 * base); continue; }
          if (maxD > 0 && Math.abs(t.length - q.length) <= maxD) {
            var d = editDistance(q, t, maxD);
            if (d <= maxD) { best = Math.max(best, (doc.title.indexOf(t) > -1 ? 7 : 4.5) * (1 - d * 0.18) * base); continue; }
          }
          if (q.length >= 6 && t.length >= 5) {
            var dc = dice(q, t);
            if (dc >= 0.6) best = Math.max(best, 4 * dc * base);
          }
        }
      }
      return best;
    }

    function search(index, query, syn, limit){
      var tokens = tokenize(query);
      if (!tokens.length) return [];
      var expanded = expandTokens(tokens, syn);
      var required = expanded.filter(function(alts){ return alts.indexOf('__optional__') < 0; }).length;
      var results = [];
      for (var d = 0; d < index.docs.length; d++) {
        var doc = index.docs[d], total = 0, matched = 0;
        for (var t = 0; t < expanded.length; t++) {
          var sc = scoreToken(expanded[t], doc);
          if (sc > 0) { total += sc; if (expanded[t].indexOf('__optional__') < 0) matched++; }
        }
        if (!matched) continue;
        // Bij meerdere woorden moeten (bijna) alle woorden matchen
        var missing = required - matched;
        if (required >= 3 ? missing > 1 : missing > 0) continue;
        total -= missing * 3;
        if (doc.item.a === false) total -= 1.5;
        if (doc.title.length <= 6) total += 0.4; // korte, specifieke titels iets omhoog
        results.push({ item: doc.item, score: total });
      }
      results.sort(function(a, b){ return b.score - a.score || (a.item.t > b.item.t ? 1 : -1); });
      return results.slice(0, limit || 8);
    }

    // "Bedoelde je": vervang elk querywoord dat niet in de woordenlijst voorkomt door het dichtstbijzijnde woord
    function suggest(index, query, syn){
      var tokens = tokenize(query);
      if (!tokens.length) return null;
      var changed = false, out = [];
      tokens.forEach(function(q){
        if (index.vocab[q] || (syn && syn.map[q])) { out.push(q); return; }
        // prefix-match aanwezig? dan is het waarschijnlijk gewoon nog niet uitgetypt
        var hasPrefix = false;
        for (var i = 0; i < index.vocabList.length; i++) { if (index.vocabList[i].w.indexOf(q) === 0) { hasPrefix = true; break; } }
        if (hasPrefix && q.length <= 3) { out.push(q); return; }
        var maxD = Math.max(1, allowedDistance(q.length)), best = null, bestScore = -1;
        for (var j = 0; j < index.vocabList.length; j++) {
          var v = index.vocabList[j];
          if (Math.abs(v.w.length - q.length) > maxD) continue;
          var d = editDistance(q, v.w, maxD);
          if (d > maxD) continue;
          var sc = (maxD - d + 1) * 10 + Math.log(v.n + 1);
          if (sc > bestScore) { bestScore = sc; best = v.w; }
        }
        if (best && best !== q) { out.push(best); changed = true; } else out.push(q);
      });
      return changed ? out.join(' ') : null;
    }

    return { normalize: normalize, tokenize: tokenize, editDistance: editDistance, parseSynonyms: parseSynonyms,
             expandTokens: expandTokens, buildIndex: buildIndex, buildIndexAsync: buildIndexAsync, search: search, suggest: suggest, dice: dice };
  })();
  /* ============================ VCT-CORE-END ============================ */

  if (typeof module !== 'undefined' && module.exports) { module.exports = CORE; return; }

  /* ---------------- helpers ---------------- */
  var $ = function(sel, ctx){ return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
  var store = {
    get: function(k, d){ try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch(e){ return d; } },
    set: function(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} },
    del: function(k){ try { localStorage.removeItem(k); } catch(e){} }
  };
  function money(cents){
    if (cents == null || isNaN(cents)) return '';
    var fmt = CFG.moneyFormat || ('€{' + '{amount_with_comma_separator}}');
    var v = Number(cents) / 100;
    function fixed(dec, thou, decSep){
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    }
    var out;
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') > -1) out = fixed(0, '.', ',');
    else if (fmt.indexOf('amount_with_comma_separator') > -1) out = fixed(2, '.', ',');
    else if (fmt.indexOf('amount_no_decimals') > -1) out = fixed(0, ',', '.');
    else if (fmt.indexOf('amount_with_apostrophe_separator') > -1) out = fixed(2, "'", '.');
    else out = fixed(2, ',', '.');
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/g, out).replace(/<[^>]+>/g, '').trim();
  }
  function toCents(p){ // Shopify geeft soms "12.95" (string, euro) en soms 1295 (cents)
    if (p == null) return null;
    if (typeof p === 'number') return p > 0 && p % 1 === 0 && p >= 100 ? p : Math.round(p * 100);
    var n = parseFloat(String(p).replace(',', '.'));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function imgUrl(src, w){
    if (!src) return '';
    if (/_\d+x\d*\./.test(src) || src.indexOf('width=') > -1) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 240);
  }
  function highlight(text, query){
    var t = esc(text);
    if (!query) return t;
    var words = CORE.tokenize(query).filter(function(w){ return w.length >= 2; });
    if (!words.length) return t;
    var re = new RegExp('(' + words.map(function(w){ return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'gi');
    return t.replace(re, '<mark>$1</mark>');
  }
  function debounce(fn, ms){ var t; return function(){ var a = arguments, c = this; clearTimeout(t); t = setTimeout(function(){ fn.apply(c, a); }, ms); }; }
  // Vertaalde teksten (NL/DE/FR) uit de config; %{q}, %{s} en %{n} worden in één keer ingevuld
  var T = CFG.t || {};
  function tr(key, vars){ return String(T[key] || '').replace(/%\{(\w+)\}/g, function(m, k){ return vars && vars[k] != null ? vars[k] : m; }); }
  /* Niets gevonden: bij een lamp- of autovraag de fittingzoeker, daarna de
     hoofdcategorieën uit het menu en de klantenservice */
  var LAMP_RE = /\b(h\d{1,2}|hb\d|hir\d|d\d[sr]|py?\d{1,2}w|w\d{1,2}w|t\d{1,2}|c\d?w|r\d{1,2}w|led|lamp\w*|fitting\w*|koplamp\w*|dimlicht\w*|grootlicht\w*|mist\w*|xenon|halogeen|verlichting|licht|bulb\w*|lampe\w*|ampoule\w*|culot\w*|birne\w*|scheinwerfer\w*|phare\w*)\b/i;
  var MAKE_RE = /\b(volkswagen|vw|golf|polo|passat|tiguan|audi|bmw|mercedes|opel|ford|peugeot|renault|toyota|kia|hyundai|skoda|seat|cupra|volvo|fiat|citroen|mazda|nissan|mini|tesla|dacia|suzuki|honda|mitsubishi|jeep|porsche|lexus|jaguar|land ?rover|alfa ?romeo|smart)\b/i;
  function emptyExtras(q){
    var h = '';
    var fold = String(q || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (CFG.fzUrl && (LAMP_RE.test(fold) || MAKE_RE.test(fold))) {
      h += '<a class="vct-ss__fz" href="' + esc(CFG.fzUrl) + '" data-vct-item>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>' +
        '<span class="vct-ss__fz-text"><strong>' + esc(tr('fzTitle')) + '</strong>' + esc(tr('fzSub')) + '</span>' +
        '<span class="vct-ss__fz-btn">' + esc(tr('fzBtn')) + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></span></a>';
    }
    if (CFG.categories && CFG.categories.length) {
      h += '<div class="vct-ss__section vct-ss__empty-more"><h3 class="vct-ss__title">' + esc(tr('browse')) + '</h3><ul class="vct-ss__list vct-ss__list--chips">' +
        CFG.categories.map(function(c){ return '<li><a href="' + esc(c.u) + '" data-vct-item><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg><span>' + esc(c.t) + '</span></a></li>'; }).join('') +
        '</ul></div>';
    }
    if (CFG.contactUrl) h += '<p class="vct-ss__help">' + esc(tr('helpText')) + ' <a href="' + esc(CFG.contactUrl) + '">' + esc(tr('helpBtn')) + '</a></p>';
    return h;
  }


  /* ---------------- product-normalisatie (uit 4 verschillende API-vormen) ---------------- */
  function normProduct(p, source){
    if (!p) return null;
    var out = { id: p.id, title: p.t || p.title, handle: p.h || p.handle, url: p.u || p.url || (CFG.root.replace(/\/$/, '') + '/products/' + (p.h || p.handle)), available: p.a !== undefined ? p.a : (p.available !== undefined ? p.available : true) };
    if (source === 'index') { out.price = p.p; out.compare = p.c || 0; out.image = p.i; out.type = p.y; out.vendor = p.v; }
    else if (source === 'predictive') { out.price = toCents(p.price); out.compare = toCents(p.compare_at_price || p.compare_at_price_max) || 0; out.image = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image; out.type = p.type; out.vendor = p.vendor; }
    else if (source === 'reco') { out.price = p.price; out.compare = p.compare_at_price || 0; out.image = p.featured_image; out.type = p.type; out.vendor = p.vendor; }
    else if (source === 'products_json') { var v0 = (p.variants && p.variants[0]) || {}; out.price = toCents(v0.price); out.compare = toCents(v0.compare_at_price) || 0; out.image = p.images && p.images[0] ? p.images[0].src : ''; out.type = p.product_type; out.vendor = p.vendor; out.available = p.variants ? p.variants.some(function(v){ return v.available; }) : true; }
    else if (source === 'recent') { out.price = p.p; out.compare = p.c || 0; out.image = p.i; }
    if (out.url && out.url.indexOf('?') > -1) out.url = out.url.split('?')[0];
    return out;
  }
  function cardHtml(p, query){
    var sale = p.compare && p.price && p.compare > p.price;
    var badge = !p.available ? '<span class="vct-ss__badge vct-ss__badge--out">' + tr('soldOut') + '</span>' : (sale ? '<span class="vct-ss__badge">' + tr('sale') + '</span>' : '');
    return '<a class="vct-ss__card" href="' + esc(p.url) + '" data-vct-item data-handle="' + esc(p.handle) + '">' +
      '<div class="vct-ss__img">' + (p.image ? '<img loading="lazy" src="' + esc(imgUrl(p.image, 240)) + '" alt="' + esc(p.title) + '" width="240" height="240">' : '') + '</div>' + badge +
      '<div class="vct-ss__name">' + highlight(p.title, query) + '</div>' +
      (p.vendor ? '<div class="vct-ss__meta">' + esc(p.vendor) + '</div>' : '') +
      '<div class="vct-ss__price">' + (p.price != null ? money(p.price) : '') + (sale ? '<s>' + money(p.compare) + '</s>' : '') + '</div></a>';
  }

  /* ---------------- fuzzy index laden & cachen ---------------- */
  var SYN = CORE.parseSynonyms(CFG.synonyms);
  var INDEX = null, indexLoading = null;
  var IDX_KEY = 'vct_ss_index_v1';
  function loadIndex(){
    if (!CFG.enableFuzzy) return Promise.resolve(null);
    if (INDEX) return Promise.resolve(INDEX);
    if (indexLoading) return indexLoading;
    var cached = store.get(IDX_KEY, null);
    if (cached && cached.ts && (Date.now() - cached.ts) < CFG.indexTtlHours * 3600 * 1000 && cached.items) {
      // VCT perf: cache uit localStorage blijft hergebruikt (geen netwerk), index wordt in stukjes opgebouwd
      indexLoading = CORE.buildIndexAsync(cached.items).then(function(idx){ INDEX = idx; return INDEX; })
        .catch(function(err){ console.warn('[VCT Smart Search] index opbouwen mislukt', err); indexLoading = null; return null; });
      return indexLoading;
    }
    // VCT perf: maximaal 4 pagina's tegelijk ophalen i.p.v. alle ~20 parallel
    function getPage(p){ return fetch(CFG.indexUrl + '&page=' + p, { credentials: 'same-origin' }).then(function(r){ return r.text(); }).then(JSON.parse); }
    indexLoading = getPage(1)
      .then(function(first){
        var rest = [], next = 2, total = first.pages || 1;
        function worker(){
          if (next > total) return Promise.resolve();
          var p = next++;
          return getPage(p).then(function(pg){ rest[p] = pg; return worker(); });
        }
        var workers = [];
        for (var w = 0; w < 4; w++) workers.push(worker());
        return Promise.all(workers).then(function(){
          var items = first.items;
          for (var p = 2; p <= total; p++) if (rest[p]) items = items.concat(rest[p].items);
          store.set(IDX_KEY, { ts: Date.now(), items: items });
          return CORE.buildIndexAsync(items);
        }).then(function(idx){ INDEX = idx; return INDEX; });
      })
      .catch(function(err){ console.warn('[VCT Smart Search] index laden mislukt', err); indexLoading = null; return null; });
    return indexLoading;
  }

  /* ---------------- Shopify predictive search ---------------- */
  var predictiveCtrl = null;
  function predictive(q){
    if (predictiveCtrl) predictiveCtrl.abort();
    predictiveCtrl = ('AbortController' in window) ? new AbortController() : null;
    var url = CFG.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=' + Math.max(CFG.maxProducts, 6) + '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku,body';
    return fetch(url, { signal: predictiveCtrl ? predictiveCtrl.signal : undefined, credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ return j && j.resources ? j.resources.results : null; })
      .catch(function(e){ if (e && e.name === 'AbortError') return 'aborted'; return null; });
  }

  /* ---------------- DOM refs ---------------- */
  var root = $('#vct-ss'), input = $('[data-vct-input]', root), form = $('[data-vct-form]', root), hint = $('[data-vct-hint]', root),
      home = $('[data-vct-home]', root), results = $('[data-vct-results]', root), spinner = $('[data-vct-spinner]', root),
      clearBtn = $('[data-vct-clear]', root), allBtn = $('[data-vct-all]', root), countEl = $('[data-vct-count]', root), body = $('[data-vct-body]', root);
  var isOpen = false, lastFocus = null, currentQuery = '', reqId = 0;

  /* ---------------- open / sluiten ---------------- */
  function open(prefill){
    if (isOpen) { input.focus(); return; }
    isOpen = true; lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vct-ss-lock');
    if (typeof prefill === 'string' && prefill) { input.value = prefill; onInput(); }
    setTimeout(function(){ input.focus(); }, 30);
    loadIndex();
    renderHome();
  }
  function close(){
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vct-ss-lock');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch(e){}
  }
  window.VCTSmartSearch = { open: open, close: close, search: function(q){ open(q); } };

  /* ---------------- home: recent bekeken, voor jou, recente zoekopdrachten ---------------- */
  var RV_KEY = 'vct_ss_recent_viewed', RS_KEY = 'vct_ss_recent_searches';
  (function trackCurrent(){
    var el = $('[data-vct-current-product]');
    if (!el || !CFG.enableRecent) return;
    try {
      var p = JSON.parse(el.textContent), list = store.get(RV_KEY, []).filter(function(x){ return x.id !== p.id; });
      list.unshift(p); store.set(RV_KEY, list.slice(0, 12));
    } catch(e){}
  })();
  function renderHome(){
    // Recente zoekopdrachten
    var rs = store.get(RS_KEY, []), rsWrap = $('[data-vct-recent-searches]', root), rsList = $('[data-vct-recent-searches-list]', root);
    if (rs.length) { rsList.innerHTML = rs.map(function(t){ return '<button type="button" class="vct-ss__chip" data-vct-term="' + esc(t) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' + esc(t) + '</button>'; }).join(''); rsWrap.hidden = false; }
    else rsWrap.hidden = true;
    // Recent bekeken
    var rv = CFG.enableRecent ? store.get(RV_KEY, []) : [], rvWrap = $('[data-vct-recent-viewed]', root), rvList = $('[data-vct-recent-viewed-list]', root);
    var onProductPage = !!$('[data-vct-current-product]');
    var rvShow = rv.filter(function(p, i){ return !(onProductPage && i === 0); }).slice(0, 6);
    if (rvShow.length) { rvList.innerHTML = rvShow.map(function(p){ return cardHtml(normProduct(p, 'recent')); }).join(''); rvWrap.hidden = false; }
    else rvWrap.hidden = true;
    // Voor jou
    if (CFG.enableReco && !renderHome.recoDone) { renderHome.recoDone = true; loadReco(rv); }
  }
  function loadReco(rv){
    var wrap = $('[data-vct-reco]', root), list = $('[data-vct-reco-list]', root), title = $('[data-vct-reco-title]', root);
    list.innerHTML = '<div class="vct-ss__skel" aria-hidden="true"><span></span><span></span><span></span></div><div class="vct-ss__skel" aria-hidden="true"><span></span><span></span><span></span></div><div class="vct-ss__skel" aria-hidden="true"><span></span><span></span><span></span></div><div class="vct-ss__skel" aria-hidden="true"><span></span><span></span><span></span></div>';
    wrap.hidden = false;
    var seeds = [];
    fetch(CFG.root.replace(/\/$/, '') + '/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; })
      .then(function(cart){
        var cartIds = cart && cart.items ? cart.items.map(function(i){ return i.product_id; }) : [];
        cartIds.slice(0, 2).forEach(function(id){ seeds.push({ id: id, intent: 'complementary' }); });
        rv.slice(0, 2).forEach(function(p){ seeds.push({ id: p.id, intent: 'related' }); });
        var exclude = {}; cartIds.concat(rv.map(function(p){ return p.id; })).forEach(function(id){ exclude[id] = 1; });
        var base = CFG.root.replace(/\/$/, '') + '/recommendations/products.json?limit=8';
        var calls = seeds.map(function(s){ return fetch(base + '&product_id=' + s.id + '&intent=' + s.intent, { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.json() : { products: [] }; }).catch(function(){ return { products: [] }; }); });
        return Promise.all(calls).then(function(res){
          var merged = [], seen = {};
          // Rond-robin mergen zodat elk seed-product vertegenwoordigd is
          for (var i = 0; i < 8; i++) res.forEach(function(r){ var p = (r.products || [])[i]; if (p && !seen[p.id] && !exclude[p.id]) { seen[p.id] = 1; merged.push(normProduct(p, 'reco')); } });
          if (merged.length >= 4) { title.textContent = cartIds.length ? tr('forCart') : tr('forYou'); return merged.slice(0, 8); }
          if (!CFG.fallbackCollection) return merged;
          return fetch(CFG.root.replace(/\/$/, '') + '/collections/' + CFG.fallbackCollection + '/products.json?limit=8', { credentials: 'same-origin' })
            .then(function(r){ return r.ok ? r.json() : { products: [] }; }).catch(function(){ return { products: [] }; })
            .then(function(j){
              title.textContent = tr('popular');
              (j.products || []).forEach(function(p){ if (!seen[p.id]) { seen[p.id] = 1; merged.push(normProduct(p, 'products_json')); } });
              return merged.slice(0, 8);
            });
        });
      })
      .then(function(items){
        if (!items || !items.length) { wrap.hidden = true; return; }
        list.innerHTML = items.map(function(p){ return cardHtml(p); }).join('');
      });
  }
  function rememberSearch(q){
    q = q.trim(); if (q.length < 2) return;
    var list = store.get(RS_KEY, []).filter(function(x){ return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q); store.set(RS_KEY, list.slice(0, 6));
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'search', search_term: q }); } catch(e){}
  }

  /* ---------------- zoeken & renderen ---------------- */
  function setBusy(b){ spinner.hidden = !b; }
  function showHome(){ results.hidden = true; home.hidden = false; hint.innerHTML = ''; allBtn.hidden = true; countEl.textContent = ''; clearBtn.hidden = true; }

  function runSearch(q){
    var my = ++reqId; currentQuery = q;
    setBusy(true);
    var pPred = predictive(q);
    // VCT perf: is de fuzzy-index nog niet klaar (wordt pas bij eerste interactie geladen), wacht er dan
    // niet op: toon direct de Shopify-resultaten (met de bestaande "index laden"-melding) en vul aan
    // zodra de index klaar is en de zoekterm nog dezelfde is.
    var idxPending = CFG.enableFuzzy && !INDEX;
    var pIdx = loadIndex();
    var pFuzzy = idxPending ? Promise.resolve(null) : pIdx.then(function(idx){ return idx ? { hits: CORE.search(idx, q, SYN, CFG.maxProducts), suggestion: CORE.suggest(idx, q, SYN) } : null; });
    Promise.all([pPred, pFuzzy]).then(function(res){
      if (my !== reqId) return;
      var pred = res[0], fz = res[1];
      if (pred === 'aborted') return;
      setBusy(false);
      render(q, pred, fz);
      if (idxPending) pIdx.then(function(idx){
        if (!idx || my !== reqId) return;
        render(q, pred, { hits: CORE.search(idx, q, SYN, CFG.maxProducts), suggestion: CORE.suggest(idx, q, SYN) });
      });
    });
  }

  function render(q, pred, fz){
    var products = [], seen = {};
    var shopifyProducts = pred && pred.products ? pred.products : [];
    shopifyProducts.forEach(function(p){ var n = normProduct(p, 'predictive'); if (!seen[n.handle]) { seen[n.handle] = 1; products.push(n); } });
    var fuzzyHits = fz && fz.hits ? fz.hits : [];
    // Fuzzy alleen aanvullen als Shopify weinig vond, en alleen met redelijke scores
    var minScore = products.length ? 9 : 4;
    fuzzyHits.forEach(function(h){ var n = normProduct(h.item, 'index'); if (h.score >= minScore && !seen[n.handle] && products.length < CFG.maxProducts) { seen[n.handle] = 1; products.push(n); } });
    var collections = pred && pred.collections ? pred.collections.slice(0, 6) : [];
    var pages = pred && pred.pages ? pred.pages.slice(0, 4) : [];
    var articles = pred && pred.articles ? pred.articles.slice(0, 6) : [];
    var usedFuzzyOnly = !shopifyProducts.length && products.length > 0;
    var suggestion = fz && fz.suggestion;

    // Hint / bedoelde je
    hint.innerHTML = '';
    if (suggestion && suggestion !== CORE.normalize(q) && !shopifyProducts.length) {
      hint.innerHTML = tr('didYouMean', { q: '<b>' + esc(q) + '</b>', s: '<button type="button" data-vct-term="' + esc(suggestion) + '">' + esc(suggestion) + '</button>' });
    } else if (usedFuzzyOnly) {
      hint.innerHTML = tr('closest', { q: '<b>' + esc(q) + '</b>' });
    }

    var html = '';
    if (!products.length && !collections.length && !pages.length && !articles.length) {
      html = '<div class="vct-ss__empty"><span class="vct-ss__empty-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg></span><strong>' + tr('nothingFound', { q: esc(q) }) + '</strong>' + tr('nothingHelp') + '</div>';
      if (INDEX === null && CFG.enableFuzzy) html += '<div class="vct-ss__empty" style="padding-top:0"><span class="vct-ss__spinner" style="display:inline-block;vertical-align:middle"></span> ' + tr('indexLoading') + '</div>';
      html += emptyExtras(q);
    } else {
      html += '<div class="vct-ss__cols"><div>';
      if (products.length) {
        html += '<div class="vct-ss__section"><h3 class="vct-ss__title">' + tr('products') + '</h3><div class="vct-ss__grid">' + products.map(function(p){ return cardHtml(p, q); }).join('') + '</div></div>';
      } else {
        html += '<div class="vct-ss__empty"><strong>' + tr('noProducts', { q: esc(q) }) + '</strong>' + tr('butFound') + '</div>';
      }
      html += '</div><aside>';
      if (collections.length) html += '<div class="vct-ss__section"><h3 class="vct-ss__title">' + tr('collections') + '</h3><ul class="vct-ss__list vct-ss__list--chips">' + collections.map(function(c){ return '<li><a href="' + esc(c.url) + '" data-vct-item><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg><span>' + highlight(c.title, q) + '</span></a></li>'; }).join('') + '</ul></div>';
      if (articles.length) html += '<div class="vct-ss__section"><h3 class="vct-ss__title">' + tr('articles') + '</h3><ul class="vct-ss__list">' + articles.map(function(a){ return '<li><a href="' + esc(a.url) + '" data-vct-item><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h12a3 3 0 0 1 3 3v11H7a3 3 0 0 1-3-3z"/><path d="M8 9h7M8 13h7"/></svg><span>' + highlight(a.title, q) + '</span></a></li>'; }).join('') + '</ul></div>';
      if (pages.length) html += '<div class="vct-ss__section"><h3 class="vct-ss__title">' + tr('pages') + '</h3><ul class="vct-ss__list">' + pages.map(function(p){ return '<li><a href="' + esc(p.url) + '" data-vct-item><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h8l5 5v13H6z"/><path d="M14 3v5h5"/></svg><span>' + highlight(p.title, q) + '</span></a></li>'; }).join('') + '</ul></div>';
      // Rechterkolom nooit leeg: vul aan met gerelateerde zoektermen (trending + eigen recente)
      var related = $$('[data-vct-home] [data-vct-term]').map(function(b){ return b.getAttribute('data-vct-term'); }).filter(function(t, i, a){ return a.indexOf(t) === i && CORE.normalize(t) !== CORE.normalize(q); }).slice(0, 8);
      if (related.length && (articles.length + collections.length + pages.length) < 4) html += '<div class="vct-ss__section"><h3 class="vct-ss__title">' + tr('related') + '</h3><div class="vct-ss__chips">' + related.map(function(t){ return '<button type="button" class="vct-ss__chip" data-vct-term="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div></div>';
      html += '<div class="vct-ss__section vct-ss__tip"><p>' + tr('enterTip') + '</p></div>';
      html += '</aside></div>';
    }
    results.innerHTML = html;
    results.hidden = false; home.hidden = true;
    var allQ = (suggestion && !shopifyProducts.length) ? suggestion : q;
    allBtn.setAttribute('data-q', allQ);
    allBtn.hidden = false; allBtn.textContent = ''; allBtn.insertAdjacentHTML('beforeend', tr('allResultsFor', { q: esc(allQ) }) + ' <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>');
    countEl.textContent = products.length ? tr(products.length === 1 ? 'countOne' : 'countMany', { n: products.length + (shopifyProducts.length >= CFG.maxProducts ? '+' : '') }) : '';
    activeIndex = -1;
  }

  var onInput = debounce(function(){
    var q = input.value.trim();
    clearBtn.hidden = !q;
    if (q.length < CFG.minChars) { showHome(); reqId++; setBusy(false); return; }
    runSearch(q);
  }, 140);

  /* ---------------- toetsenbord-navigatie ---------------- */
  var activeIndex = -1;
  function items(){ return $$('[data-vct-item]', results.hidden ? home : results); }
  function setActive(i){
    var list = items(); if (!list.length) return;
    list.forEach(function(el){ el.classList.remove('is-active'); });
    activeIndex = (i + list.length) % list.length;
    list[activeIndex].classList.add('is-active');
    list[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  /* ---------------- events ---------------- */
  input.addEventListener('input', onInput);
  input.addEventListener('keydown', function(e){
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); }
    else if (e.key === 'Enter') { e.preventDefault(); var el = activeIndex > -1 ? items()[activeIndex] : null; if (el) { rememberSearch(input.value); window.location.href = el.href; } else goToResults(allBtn.getAttribute('data-q') || input.value); }
    else if (e.key === 'Escape') { e.stopPropagation(); if (input.value) { input.value = ''; showHome(); } else close(); }
  });
  function goToResults(q){
    q = (q || '').trim(); if (!q) return;
    rememberSearch(q);
    window.location.href = CFG.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product%2Carticle%2Cpage';
  }
  allBtn.addEventListener('click', function(){ goToResults(allBtn.getAttribute('data-q') || input.value); });
  clearBtn.addEventListener('click', function(){ input.value = ''; showHome(); input.focus(); });
  $('[data-vct-clear-searches]', root).addEventListener('click', function(){ store.del(RS_KEY); renderHome(); });
  root.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-vct-term]') : null;
    if (t) { input.value = t.getAttribute('data-vct-term'); clearBtn.hidden = false; runSearch(input.value); input.focus(); return; }
    var link = e.target.closest ? e.target.closest('[data-vct-item]') : null;
    if (link && input.value.trim()) rememberSearch(input.value);
    if (e.target.hasAttribute && (e.target.hasAttribute('data-vct-close') || (e.target.closest && e.target.closest('[data-vct-close]')))) close();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && isOpen) { close(); return; }
    if (!CFG.hotkeys) return;
    var tag = (document.activeElement && document.activeElement.tagName || '').toLowerCase();
    var typing = tag === 'input' || tag === 'textarea' || tag === 'select' || (document.activeElement && document.activeElement.isContentEditable);
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); }
    else if (e.key === '/' && !typing && !isOpen) { e.preventDefault(); open(); }
  });

  // Koppel aan de bestaande zoekknoppen/-velden van het thema
  // Koppel aan de bestaande zoekknoppen/-velden van het thema.
  // We onderscheppen de gebeurtenis op documentniveau in de capture-fase, dus vóór het thema
  // zijn eigen zoekpaneel kan openen, en stoppen hem daar meteen.
  function matchTrigger(target){
    var sel = (CFG.triggers || '').trim();
    if (!sel || !target || !target.closest) return null;
    if (target.closest('#vct-ss')) return null;
    try { return target.closest(sel); } catch(e){ console.warn('[VCT Smart Search] ongeldige selector', sel); return null; }
  }
  function intercept(e){
    var el = matchTrigger(e.target);
    if (!el) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    if (e.type === 'click' || e.type === 'focusin' || e.type === 'keydown') {
      var v = el.tagName.toLowerCase() === 'input' ? el.value : '';
      if (el.blur) el.blur();
      open(v);
      if (v) { input.value = v; onInput(); }
    }
  }
  ['pointerdown', 'mousedown', 'touchstart', 'click', 'focusin'].forEach(function(t){ document.addEventListener(t, intercept, true); });
  document.addEventListener('keydown', function(e){ if (e.key !== 'Tab' && matchTrigger(e.target)) intercept(e); }, true);
  // Mocht het thema zijn zoekpaneel via een class op html/body openen, sluit die dan weer
  function closeThemeSearch(){
    ['search-open', 'search-active', 'has-search', 'show-search', 'overlay-search'].forEach(function(c){ document.documentElement.classList.remove(c); document.body.classList.remove(c); });
    $$('.search-overlay, .header-search, .l4se, .f8se-overlay').forEach(function(el){ if (el.closest && el.closest('#vct-ss')) return; el.classList.remove('active', 'open', 'is-open', 'visible'); });
  }
  var _open = open;
  open = function(prefill){ closeThemeSearch(); _open(prefill); setTimeout(closeThemeSearch, 50); };
  window.VCTSmartSearch.open = open; window.VCTSmartSearch.search = function(q){ open(q); };
  // ?q= in URL (b.v. zoekpagina) -> zoekterm onthouden
  try { var qs = new URLSearchParams(location.search).get('q'); if (qs && location.pathname.indexOf('/search') > -1) rememberSearch(qs); } catch(e){}
  // Zoekresultatenpagina zonder resultaten? Toon daar "bedoelde je" + de beste fuzzy-matches
  if (CFG.searchPage && CFG.searchPage.count === 0 && CFG.searchPage.terms && CFG.enableFuzzy) {
    loadIndex().then(function(idx){
      if (!idx) return;
      var q = CFG.searchPage.terms, sug = CORE.suggest(idx, q, SYN), hits = CORE.search(idx, q, SYN, 8).filter(function(h){ return h.score >= 4; });
      if (!sug && !hits.length) return;
      var target = $('[data-vct-noresults]') || $('.collection-wrapper .results') || $('.collection-wrapper > div') || $('main') || document.body;
      var box = document.createElement('div');
      box.className = 'vct-ss vct-ss--inline';
      box.style.cssText = 'position:static;opacity:1;visibility:visible;pointer-events:auto;display:block;padding:0;margin:24px 0';
      var h = '';
      if (sug) h += '<p class="vct-ss__suggest">' + tr('noResults', { q: '<b>' + esc(q) + '</b>', s: '<a href="' + esc(CFG.searchUrl) + '?q=' + encodeURIComponent(sug) + '">' + esc(sug) + '</a>' }) + '</p>';
      if (hits.length) h += '<div class="vct-ss__section"><h3 class="vct-ss__title">' + tr('closestTitle') + '</h3><div class="vct-ss__grid">' + hits.map(function(x){ return cardHtml(normProduct(x.item, 'index'), q); }).join('') + '</div></div>';
      box.innerHTML = h;
      target.insertBefore(box, target.firstChild);
    });
  }
  // VCT perf: geen prefetch meer bij idle (was ~20 requests / ~360 KB + lange taak per nieuwe bezoeker).
  // De index wordt pas geladen bij de eerste interactie met een zoekveld/-knop: open() (via intercept op
  // pointerdown/focusin/keydown/click) roept loadIndex() aan; hieronder ook voor directe focus/toetsen in het eigen veld.
  ['pointerdown', 'focus', 'keydown'].forEach(function(t){ input.addEventListener(t, function(){ loadIndex(); }, { once: true, passive: true }); });
})();
